import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { PackageCheck } from "lucide-react";
import { resolveImg } from "@/lib/img";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Orders() {
  const { user, loading: authLoading } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { setLoading(false); return; }
    axios.get(`${API}/orders`).then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, [user, authLoading]);

  if (authLoading) return null;
  if (!user) {
    return (
      <div className="container-app px-6 py-20 text-center">
        <h1 className="font-heading text-3xl font-bold">Please sign in to view orders</h1>
        <Link to="/login"><Button className="mt-6 rounded-full bg-[#638971] text-white">Sign in</Button></Link>
      </div>
    );
  }

  return (
    <div className="container-app px-6 md:px-10 py-10">
      <h1 className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A]">My orders</h1>
      {loading ? (
        <div className="mt-8 text-[#595959]">Loading…</div>
      ) : orders.length === 0 ? (
        <div className="mt-16 text-center">
          <PackageCheck size={56} className="mx-auto text-[#638971] mb-4"/>
          <div className="text-[#595959]">No orders yet.</div>
          <Link to="/products" data-testid="empty-orders-shop-btn">
            <Button className="mt-6 rounded-full bg-[#638971] hover:bg-[#4F705B] text-white">Start shopping</Button>
          </Link>
        </div>
      ) : (
        <div className="mt-8 space-y-4">
          {orders.map((o) => (
            <div key={o.id} data-testid={`order-${o.id}`}
                 className="bg-white rounded-2xl border border-gray-100 p-6">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#638971] font-bold">Order</div>
                  <div className="text-sm font-mono text-[#2C4035]">{o.session_id?.slice(-12)}</div>
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#595959] font-semibold">Status</div>
                  <div className={`text-sm font-semibold ${o.payment_status === "paid" ? "text-[#638971]" : "text-[#E48967]"}`}>
                    {o.payment_status === "paid" ? (o.status === "fulfilled" ? "Fulfilled" : "Paid") : o.payment_status}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xs uppercase tracking-wider text-[#595959] font-semibold">Total</div>
                  <div className="font-heading font-bold text-[#2C4035]">${o.amount.toFixed(2)}</div>
                </div>
              </div>
              <div className="mt-4 grid gap-2">
                {o.items.map((it, i) => (
                  <div key={i} className="flex gap-3 items-center text-sm">
                    <img src={resolveImg(it.image_url)} alt="" className="w-10 h-10 rounded object-cover"/>
                    <div className="flex-1">{it.name} × {it.quantity}</div>
                    <div className="font-medium">${(it.price * it.quantity).toFixed(2)}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
